import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Button } from 'primereact/button';

interface RequestHoursDialogProps {
  visible: boolean;
  onHide: () => void;
  onConfirm: (requestedHours: number, justification: string) => void;
  loading: boolean;
}

const RequestHoursDialog: React.FC<RequestHoursDialogProps> = ({
  visible,
  onHide,
  onConfirm,
  loading,
}) => {
  const [requestedHours, setRequestedHours] = useState<string>('');
  const [justification, setJustification] = useState<string>('');

  const handleConfirm = () => {
    const hours = parseInt(requestedHours);
    if (!isNaN(hours) && justification.trim()) {
      onConfirm(hours, justification.trim());
    }
  };

  const handleHide = () => {
    setRequestedHours('');
    setJustification('');
    onHide();
  };

  const isValid =
    !isNaN(parseInt(requestedHours)) && justification.trim().length > 0;

  return (
    <Dialog
      header="בקשת שעות הוראה נוספות"
      visible={visible}
      onHide={handleHide}
      style={{ width: '450px' }}
      modal
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div>
          <label
            htmlFor="requestedHours"
            style={{ display: 'block', marginBottom: '4px' }}
          >
            מספר שעות נוספות מבוקשות:
          </label>
          <InputText
            id="requestedHours"
            value={requestedHours}
            onChange={(e) => setRequestedHours(e.target.value)}
            type="number"
            placeholder="הכנס מספר שעות"
            style={{ width: '100%' }}
            disabled={loading}
          />
        </div>

        <div>
          <label
            htmlFor="justification"
            style={{ display: 'block', marginBottom: '4px' }}
          >
            הצדקה לבקשה:
          </label>
          <InputTextarea
            id="justification"
            value={justification}
            onChange={(e) => setJustification(e.target.value)}
            placeholder="הכנס הצדקה לבקשת השעות הנוספות"
            rows={4}
            style={{ width: '100%' }}
            disabled={loading}
          />
        </div>

        <div
          style={{
            backgroundColor: '#f8f9fa',
            padding: '12px',
            borderRadius: '4px',
            fontSize: '14px',
            color: '#666',
          }}
        >
          <strong>שים לב:</strong> לאחר האישור הבקשה עוברת לאישור ההנהלה. אין
          באישור זה אישור סופי לשינוי מכסת שעות הקורס.
        </div>

        <div
          style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px' }}
        >
          <Button
            label="ביטול"
            severity="secondary"
            onClick={handleHide}
            disabled={loading}
          />
          <Button
            label="שלח בקשה"
            onClick={handleConfirm}
            disabled={!isValid || loading}
            loading={loading}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default RequestHoursDialog;
